import { Tooltip } from '@findy-code/yuffie/ui/tooltip';

import { ReactComponent as CompanyAiUsageStart } from '../images/company-ai-usage-star.svg';
import styles from './company-ai-usage-tag.component.module.scss';

export const CompanyAiUsageTag = () => (
  <div>
    <span
      className={styles.tagContent}
      data-tooltip-id="tooltip-company-ai-usage-tag"
    >
      <CompanyAiUsageStart aria-hidden="true" height={16} width={13} />
      <span>生成AI活用企業</span>
    </span>
    <Tooltip
      closeEvents={{ mouseout: true }}
      id="tooltip-company-ai-usage-tag"
      place="bottom-start"
      style={{ maxWidth: '350px', zIndex: 1 }}
    >
      <div className={styles.tooltipText}>
        生成AI活用企業とは？：
        <br />
        生成AIをサービスや業務に活用している企業の事を指します。
        <br />
        実際の活用状況や、活用しているサービス/ツールについての情報をFindy内で確認することができます。
      </div>
    </Tooltip>
  </div>
);
